/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { db } from './firebase';
import {
  collection, addDoc, query, where, onSnapshot, orderBy,
  serverTimestamp, doc, getDoc, getDocs, updateDoc, arrayUnion,
  arrayRemove, deleteDoc, limit, setDoc, increment
} from 'firebase/firestore';
import { Avatar, Icon, SpoilerBlur } from './ui';

// ── Generar código de invitación ──────────────────────────────────────────────
function generarCodigo() {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
}

// ── Modal crear club ──────────────────────────────────────────────────────────
function ModalCrearClub({ userId, perfil, onCerrar, onCreado }) {
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [guardando, setGuardando] = useState(false);

  const crear = async () => {
    if (!nombre.trim()) return;
    setGuardando(true);
    try {
      const codigo = generarCodigo();
      const docData = {
        nombre: nombre.trim(),
        descripcion: descripcion.trim(),
        creadorId: userId,
        creadorNombre: perfil.nombre || 'Usuario',
        codigo,
        miembros: [userId],
        miembrosInfo: [{ id: userId, nombre: perfil.nombre || 'Usuario', foto: perfil.foto || null, rol: 'admin' }],
        libroMes: null,
        creadoEn: serverTimestamp(),
        activo: true,
      };
      // Si el creador es autor o editorial verificado, el club hereda el verificado
      if (perfil.verificado === 'autor' || perfil.verificado === 'editorial') {
        docData.verificado = perfil.verificado;
      }
      const ref = await addDoc(collection(db, "clubs"), docData);

      // Si es autor/editorial verificado, registrar el club en clubs_publicos
      // — versión resumida y sin datos privados, para mostrarlo en su perfil
      // a visitantes que todavía no son miembros (las reglas de "clubs" son
      // privadas y solo legibles por miembros, así que esto vive aparte).
      if (docData.verificado) {
        try {
          await setDoc(doc(db, 'clubs_publicos', ref.id), {
            clubId: ref.id,
            nombre: docData.nombre,
            descripcion: docData.descripcion,
            creadorId: userId,
            creadorNombre: docData.creadorNombre,
            numMiembros: 1,
            creadoEn: serverTimestamp(),
          });
        } catch (e) { console.error('Error creando registro público del club:', e); }
      }

      onCreado(ref.id);
      onCerrar();
    } catch (e) { console.error(e); }
    setGuardando(false);
  };

  return (
    <div className="modal-overlay" onClick={onCerrar}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 900 }}>Crear club</h3>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer' }}><Icon.Close /></button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Nombre del club</label>
            <input className="input-modal" placeholder="Ej: Las Chicas Lectoras" value={nombre} onChange={e => setNombre(e.target.value)} maxLength={50} />
          </div>
          <div>
            <label style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Descripción (opcional)</label>
            <textarea className="input-modal" placeholder="¿De qué va vuestro club?" value={descripcion} onChange={e => setDescripcion(e.target.value)} style={{ height: '70px', resize: 'none' }} maxLength={200} />
          </div>
        </div>
        <button onClick={crear} disabled={guardando || !nombre.trim()} className="btn-verde" style={{ marginTop: '20px' }}>
          {guardando ? 'Creando...' : 'Crear club'}
        </button>
      </div>
    </div>
  );
}

// ── Modal unirse a club ───────────────────────────────────────────────────────
function ModalUnirseClub({ userId, perfil, onCerrar, onUnido }) {
  const [codigo, setCodigo] = useState('');
  const [buscando, setBuscando] = useState(false);
  const [error, setError] = useState('');

  const unirse = async () => {
    if (!codigo.trim()) return;
    setBuscando(true);
    setError('');
    try {
      const snap = await getDocs(
        query(collection(db, "clubs"), where("codigo", "==", codigo.trim().toUpperCase()))
      );
      if (snap.empty) { setError('Código no válido. Comprueba que es correcto.'); setBuscando(false); return; }
      const clubDoc = snap.docs[0];
      const club = clubDoc.data();
      if (club.miembros.includes(userId)) { setError('Ya eres miembro de este club.'); setBuscando(false); return; }

      // Verificar límite de miembros
      const esClubVerificado = club.verificado === 'autor' || club.verificado === 'editorial';
      const limite = esClubVerificado ? 500 : 50;
      if (club.miembros.length >= limite) {
        setError(`Este club ha alcanzado el límite de ${limite} miembros.`);
        setBuscando(false);
        return;
      }

      await updateDoc(clubDoc.ref, {
        miembros: arrayUnion(userId),
        miembrosInfo: arrayUnion({ id: userId, nombre: perfil.nombre || 'Usuario', foto: perfil.foto || null, rol: 'miembro' })
      });
      onUnido(clubDoc.id);
      onCerrar();
    } catch (e) { setError('Error al unirse. Inténtalo de nuevo.'); }
    setBuscando(false);
  };

  return (
    <div className="modal-overlay" onClick={onCerrar}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 900 }}>Unirse a un club</h3>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer' }}><Icon.Close /></button>
        </div>
        <p style={{ color: '#555', fontSize: '13px', margin: '0 0 16px' }}>Pide el código a quien te invitó</p>
        <input className="input-modal" placeholder="Ej: AB12CD" value={codigo}
          onChange={e => setCodigo(e.target.value.toUpperCase())} maxLength={6}
          style={{ fontSize: '20px', letterSpacing: '4px', textAlign: 'center', fontWeight: 'bold' }} />
        {error && <p style={{ color: '#f44336', fontSize: '13px', margin: '8px 0 0' }}>{error}</p>}
        <button onClick={unirse} disabled={buscando || codigo.length < 6} className="btn-verde" style={{ marginTop: '16px' }}>
          {buscando ? 'Buscando...' : 'Unirse'}
        </button>
      </div>
    </div>
  );
}


// ── Votación libro del mes ────────────────────────────────────────────────────
// ── Libro fijado por el autor — sin votación, el autor decide directamente ───
function LibroDelMesAutor({ club, userId }) {
  const [buscando, setBuscando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [mostrarBusqueda, setMostrarBusqueda] = useState(false);
  const esCreador = club.creadorId === userId;

  const buscarLibro = async () => {
    if (!busqueda.trim()) return;
    setBuscando(true);
    try {
      const ctrl = new AbortController();
      setTimeout(() => ctrl.abort(), 8000);
      const resp = await fetch(`https://openlibrary.org/search.json?q=${encodeURIComponent(busqueda)}&limit=5`, { signal: ctrl.signal });
      const data = await resp.json();
      setResultados((data.docs || []).filter(d => d.cover_i).slice(0, 4).map(d => ({
        titulo: d.title, autor: d.author_name?.[0] || 'Anónimo',
        portada: `https://covers.openlibrary.org/b/id/${d.cover_i}-M.jpg`,
      })));
    } catch { setResultados([]); }
    setBuscando(false);
  };

  const fijarLibro = async (libro) => {
    try {
      await updateDoc(doc(db, 'clubs', club.id), { libroMes: { ...libro, fijadoEn: serverTimestamp() } });
      setMostrarBusqueda(false); setBusqueda(''); setResultados([]);
    } catch (e) { console.error('Error fijando libro del club:', e); }
  };

  return (
    <div style={{ padding: '16px 20px', borderBottom: '1px solid #1a1a1a' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: club.libroMes || (esCreador && mostrarBusqueda) ? '12px' : 0 }}>
        <p style={{ margin: 0, fontWeight: 900, fontSize: '14px', color: '#0ea5e9' }}>✦ Libro del club</p>
        {esCreador && (
          <button onClick={() => setMostrarBusqueda(!mostrarBusqueda)}
            style={{ background: '#0ea5e918', color: '#0ea5e9', border: '1px solid #0ea5e933', borderRadius: '20px', padding: '6px 14px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>
            {club.libroMes ? 'Cambiar' : '+ Fijar libro'}
          </button>
        )}
      </div>

      {club.libroMes && !mostrarBusqueda && (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <img src={club.libroMes.portada} style={{ width: '36px', height: '52px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} alt="" onError={e => e.currentTarget.style.display='none'} />
          <div>
            <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 'bold', color: 'white' }}>{club.libroMes.titulo}</p>
            <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>{club.libroMes.autor}</p>
          </div>
        </div>
      )}

      {esCreador && mostrarBusqueda && (
        <div style={{ background: '#0a0a0a', borderRadius: '10px', padding: '12px', border: '1px solid #1a1a1a' }}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
            <input className="input-modal" style={{ marginTop: 0, flex: 1, fontSize: '13px' }}
              placeholder="Busca tu libro..." value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && buscarLibro()} />
            <button onClick={buscarLibro} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '0 14px', fontSize: '13px' }}>
              {buscando ? '...' : 'Buscar'}
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {resultados.map((l, i) => (
              <div key={i} onClick={() => fijarLibro(l)}
                style={{ display: 'flex', gap: '10px', padding: '8px', background: '#141414', borderRadius: '8px', cursor: 'pointer', alignItems: 'center', border: '1px solid #1e1e1e' }}>
                <img src={l.portada} style={{ width: '32px', height: '46px', objectFit: 'cover', borderRadius: '3px' }} alt="" onError={e => e.currentTarget.style.display='none'} />
                <div>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold' }}>{l.titulo}</p>
                  <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>{l.autor}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!club.libroMes && !mostrarBusqueda && (
        <p style={{ fontSize: '13px', color: '#333', textAlign: 'center', padding: '8px 0', margin: 0 }}>
          {esCreador ? 'Fija el libro que vais a leer en este club.' : 'El autor aún no ha fijado un libro para este club.'}
        </p>
      )}
    </div>
  );
}

function VotacionLibroMes({ club, userId }) {
  const [propuestas, setPropuestas] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [mostrarBusqueda, setMostrarBusqueda] = useState(false);
  const [error, setError] = useState('');
  const mesActual = new Date().toISOString().slice(0, 7); // "2026-05"

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, "clubs", club.id, "votaciones"), where("mes", "==", mesActual), limit(20)),
      snap => setPropuestas(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => (b.votos?.length || 0) - (a.votos?.length || 0)))
    );
    return () => unsub();
  }, [club.id, mesActual]);

  const buscarLibro = async () => {
    if (!busqueda.trim()) return;
    setBuscando(true);
    try {
      const ctrl = new AbortController();
      setTimeout(() => ctrl.abort(), 8000);
      const resp = await fetch(`https://openlibrary.org/search.json?q=${encodeURIComponent(busqueda)}&limit=5`, { signal: ctrl.signal });
      const data = await resp.json();
      setResultados((data.docs || []).filter(d => d.cover_i).slice(0, 4).map(d => ({
        titulo: d.title, autor: d.author_name?.[0] || 'Anónimo',
        portada: `https://covers.openlibrary.org/b/id/${d.cover_i}-M.jpg`,
      })));
    } catch { setResultados([]); }
    setBuscando(false);
  };

  const proponer = async (libro) => {
    // Verificar que no haya propuesto ya
    const yaPropuso = propuestas.some(p => p.proponenteId === userId);
    if (yaPropuso) { setError('Ya has propuesto un libro este mes.'); setTimeout(() => setError(''), 3000); return; }
    await addDoc(collection(db, "clubs", club.id, "votaciones"), {
      mes: mesActual, titulo: libro.titulo, autor: libro.autor,
      portada: libro.portada, proponenteId: userId, votos: [userId],
    });
    setMostrarBusqueda(false); setBusqueda(''); setResultados([]);
  };

  const votar = async (propuestaId, votos, proponenteId) => {
    if (proponenteId === userId) return; // el proponente siempre tiene su voto
    const ref = doc(db, "clubs", club.id, "votaciones", propuestaId);
    if (votos.includes(userId)) {
      await updateDoc(ref, { votos: arrayRemove(userId) });
    } else {
      await updateDoc(ref, { votos: arrayUnion(userId) });
    }
  };

  const mesNombre = new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });

  return (
    <div style={{ padding: '16px 20px', borderBottom: '1px solid #1a1a1a' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div>
          <p style={{ margin: '0 0 2px', fontWeight: 900, fontSize: '14px', color: 'white' }}>Libro del mes</p>
          <p style={{ margin: 0, fontSize: '11px', color: '#444', textTransform: 'capitalize' }}>{mesNombre}</p>
        </div>
        <button onClick={() => setMostrarBusqueda(!mostrarBusqueda)}
          style={{ background: '#1DB95418', color: '#1DB954', border: '1px solid #1DB95433', borderRadius: '20px', padding: '6px 14px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>
          + Proponer
        </button>
      </div>

      {error && <p style={{ color: '#f44336', fontSize: '12px', margin: '0 0 10px' }}>{error}</p>}

      {/* Buscador */}
      {mostrarBusqueda && (
        <div style={{ marginBottom: '12px', background: '#0a0a0a', borderRadius: '10px', padding: '12px', border: '1px solid #1a1a1a' }}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
            <input className="input-modal" style={{ marginTop: 0, flex: 1, fontSize: '13px' }}
              placeholder="Busca un libro..." value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && buscarLibro()} />
            <button onClick={buscarLibro} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '0 14px', fontSize: '13px' }}>
              {buscando ? '...' : 'Buscar'}
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {resultados.map((l, i) => (
              <div key={i} onClick={() => proponer(l)}
                style={{ display: 'flex', gap: '10px', padding: '8px', background: '#141414', borderRadius: '8px', cursor: 'pointer', alignItems: 'center', border: '1px solid #1e1e1e', transition: '0.15s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = '#1DB954'}
                onMouseLeave={e => e.currentTarget.style.borderColor = '#1e1e1e'}>
                <img src={l.portada} style={{ width: '32px', height: '46px', objectFit: 'cover', borderRadius: '3px' }} alt="" onError={e => e.currentTarget.style.display='none'} />
                <div>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold' }}>{l.titulo}</p>
                  <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>{l.autor}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Propuestas */}
      {propuestas.length === 0 ? (
        <p style={{ fontSize: '13px', color: '#333', textAlign: 'center', padding: '12px 0' }}>
          Nadie ha propuesto un libro todavía. ¡Sé el primero!
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {propuestas.map((p, i) => {
            const votos = p.votos || [];
            const haVotado = votos.includes(userId);
            const esGanador = i === 0 && propuestas.length > 1;
            return (
              <div key={p.id}
                style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', background: esGanador ? '#0a1f0a' : '#141414', borderRadius: '8px', border: `1px solid ${esGanador ? '#1DB95444' : '#1e1e1e'}` }}>
                <img src={p.portada} style={{ width: '32px', height: '46px', objectFit: 'cover', borderRadius: '3px', flexShrink: 0 }} alt="" onError={e => e.currentTarget.style.display='none'} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 'bold', color: esGanador ? '#1DB954' : 'white', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {esGanador && '🏆 '}{p.titulo}
                  </p>
                  <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>{p.autor}</p>
                </div>
                <button onClick={() => votar(p.id, votos, p.proponenteId)}
                  style={{ background: haVotado ? '#1DB954' : 'transparent', color: haVotado ? 'black' : '#555', border: `1px solid ${haVotado ? '#1DB954' : '#333'}`, borderRadius: '20px', padding: '4px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', flexShrink: 0, transition: '0.2s', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  ▲ {votos.length}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Chat del club ─────────────────────────────────────────────────────────────
function ChatClub({ club, userId, perfil, onVolver }) {
  const [mensajes, setMensajes] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [esSpoiler, setEsSpoiler] = useState(false);
  const [mensajeCitado, setMensajeCitado] = useState(null);
  const chatEndRef = useRef(null);

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, "clubs", club.id, "mensajes"), orderBy("fecha", "desc"), limit(100)),
      snap => setMensajes(snap.docs.map(d => ({ id: d.id, ...d.data() })).reverse())
    );
    return () => unsub();
  }, [club.id]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensajes]);

  const ultimoEnvioClubRef = React.useRef(0);

  const enviar = async () => {
    if (!mensaje.trim() || mensaje.trim().length > 500) return;
    const ahora = Date.now();
    if (ahora - ultimoEnvioClubRef.current < 1000) return;
    ultimoEnvioClubRef.current = ahora;
    const t = mensaje.trim(), s = esSpoiler, cita = mensajeCitado;
    setMensaje(''); setEsSpoiler(false); setMensajeCitado(null);
    const msgData = {
      texto: t, spoiler: s,
      sender: { id: userId, nombre: perfil.nombre, foto: perfil.foto || null },
      fecha: serverTimestamp(),
    };
    if (cita) msgData.citando = cita;
    await addDoc(collection(db, "clubs", club.id, "mensajes"), msgData);
    await updateDoc(doc(db, "clubs", club.id), { ultimaActividad: serverTimestamp() });
    // Actualizar contador para insignias — increment() atómico, no un cálculo
    // sobre perfil.mensajes_enviados (que puede quedarse desfasado si se envían
    // varios mensajes seguidos sin que el prop perfil se refresque entre medias)
    await setDoc(doc(db, "user_stats", userId), { mensajes_enviados: increment(1) }, { merge: true }).catch(() => {});
    await updateDoc(doc(db, "users", userId), { mensajes_enviados: increment(1) }).catch(() => {});
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Header */}
      <div style={{ padding: '16px 24px', background: 'linear-gradient(to bottom, #141414, #0d0d0d)', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', gap: '14px' }}>
        <button onClick={onVolver} style={{ background: '#1a1a1a', border: '1px solid #2a2a2a', color: '#aaa', cursor: 'pointer', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: '0.2s' }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#1DB954'; e.currentTarget.style.color = '#1DB954'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#aaa'; }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
        </button>
        <div style={{ flex: 1 }}>
          <p style={{ margin: 0, fontWeight: 900, fontSize: '16px' }}>{club.nombre}</p>
          <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>{club.miembros?.length || 1} miembros</p>
        </div>
        {/* Código de invitación */}
        {club.creadorId === userId && (
          <div style={{ background: '#1DB95422', border: '1px solid #1DB95444', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer' }}
            onClick={() => { navigator.clipboard.writeText(club.codigo); }}>
            <p style={{ margin: 0, fontSize: '10px', color: '#1DB954', fontWeight: 'bold' }}>CÓDIGO</p>
            <p style={{ margin: 0, fontSize: '14px', fontWeight: 900, letterSpacing: '2px', color: 'white' }}>{club.codigo}</p>
          </div>
        )}
      </div>

      {/* Libro del club — fijado directamente por el autor, o votación para clubs normales */}
      {club.verificado ? <LibroDelMesAutor club={club} userId={userId} /> : <VotacionLibroMes club={club} userId={userId} />}

      {/* Mensajes */}
      <div className="chat-area" style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
        {mensajes.length === 0 && (
          <p style={{ textAlign: 'center', color: '#2a2a2a', marginTop: '60px', fontSize: '14px' }}>
            Sé el primero en escribir en {club.nombre}
          </p>
        )}
        {mensajes.map((m, i) => {
          const esMio = m.sender?.id === userId;
          return (
            <div key={i} className={`msg-row ${esMio ? 'mine' : ''}`}
              onMouseEnter={e => { const btn = e.currentTarget.querySelector('.reply-btn'); if (btn) btn.style.opacity = '1'; }}
              onMouseLeave={e => { const btn = e.currentTarget.querySelector('.reply-btn'); if (btn) btn.style.opacity = '0'; }}>
              <Avatar src={m.sender?.foto} nombre={m.sender?.nombre} size={32} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                {m.citando && (
                  <div style={{ background: '#1a1a1a', borderLeft: '3px solid #1DB954', borderRadius: '0 8px 8px 0', padding: '6px 10px', opacity: 0.8 }}>
                    <p style={{ margin: '0 0 2px', fontSize: '11px', fontWeight: 'bold', color: '#1DB954' }}>{m.citando.nombre}</p>
                    <p style={{ margin: 0, fontSize: '12px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '280px' }}>{m.citando.texto}</p>
                  </div>
                )}
                <div id={`msg-${m.id}`} className="msg-bubble">
                  <div style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '4px', color: '#1DB954' }}>{m.sender?.nombre}</div>
                  {m.spoiler ? <SpoilerBlur texto={m.texto} /> : m.texto}
                </div>
              </div>
              <button className="reply-btn" onClick={() => setMensajeCitado({ id: m.id, texto: m.texto, nombre: m.sender?.nombre })}
                style={{ background: 'none', border: 'none', color: '#444', cursor: 'pointer', fontSize: '16px', padding: '4px', opacity: 0, transition: '0.15s', alignSelf: 'center', flexShrink: 0 }}>↩</button>
            </div>
          );
        })}
        <div ref={chatEndRef} />
      </div>

      {/* Input */}
      <div style={{ padding: '12px 20px', background: '#0a0a0a', borderTop: '1px solid #1a1a1a' }}>
        {mensajeCitado && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#141414', borderRadius: '8px', marginBottom: '8px', borderLeft: '3px solid #1DB954' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: '0 0 2px', fontSize: '11px', fontWeight: 'bold', color: '#1DB954' }}>Respondiendo a {mensajeCitado.nombre}</p>
              <p style={{ margin: 0, fontSize: '12px', color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{mensajeCitado.texto}</p>
            </div>
            <button onClick={() => setMensajeCitado(null)} style={{ background: 'none', border: 'none', color: '#444', cursor: 'pointer', fontSize: '18px' }}>✕</button>
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '12px', color: esSpoiler ? '#f44336' : '#444' }}>
            <input type="checkbox" checked={esSpoiler} onChange={e => setEsSpoiler(e.target.checked)} style={{ accentColor: '#f44336' }} />
            Spoiler
          </label>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input enterKeyHint="send" placeholder={`Escribe en ${club.nombre}...`} value={mensaje}
          onChange={e => setMensaje(e.target.value.slice(0, 500))}
          onKeyDown={e => { if (e.key === 'Enter' && mensaje.trim()) enviar(); if (e.key === 'Escape') setMensajeCitado(null); }}
          style={{ flex: 1, background: '#141414', border: '1px solid #1e1e1e', borderRadius: '20px', padding: '10px 18px', color: 'white', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }} />
        <button onClick={enviar} disabled={!mensaje.trim()} style={{ background: mensaje.trim() ? '#1DB954' : '#1a1a1a', border: 'none', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: mensaje.trim() ? 'pointer' : 'default', flexShrink: 0, fontSize: '18px', transition: '0.2s' }}>➤</button>
        </div>
      </div>
    </div>
  );
}

// ── Lista de clubs ────────────────────────────────────────────────────────────
export function SeccionClubs({ userId, perfil, esPremium, esVerificado, onUpgrade }) {
  const puedeCrear = true;
  const [misClubs, setMisClubs] = useState([]);
  const [clubsPublicos, setCluBsPublicos] = useState([]);
  const [clubActivo, setClubActivo] = useState(null);
  const [modalCrear, setModalCrear] = useState(false);
  const [modalUnirse, setModalUnirse] = useState(false);
  const [tab, setTab] = useState('activos');
  const [cargando, setCargando] = useState(true);
  const [cargandoPublicos, setCargandoPublicos] = useState(true);
  const [solicitudesEnviadas, setSolicitudesEnviadas] = useState({});
  const [enviando, setEnviando] = useState(null);

  // Mis clubs — los que soy miembro (getDocs, no tiempo real)
  useEffect(() => {
    if (!userId) return;
    getDocs(query(collection(db, 'clubs'), where('miembros', 'array-contains', userId), limit(50)))
      .then(snap => {
        setMisClubs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setCargando(false);
      })
      .catch(() => setCargando(false));
  }, [userId]);

  // Clubs activos — todos los clubs públicos
  useEffect(() => {
    if (!userId) return;
    const cargar = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'clubs'), limit(100)));
        const todos = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        // Excluir los que ya soy miembro
        setCluBsPublicos(todos);
      } catch (e) { console.error(e); }
      setCargandoPublicos(false);
    };
    cargar();
  }, [userId]);

  // Solicitudes ya enviadas
  useEffect(() => {
    if (!userId) return;
    getDocs(query(collection(db, 'alertas'), where('emisorId', '==', userId), where('tipo', '==', 'solicitud_club')))
      .then(snap => {
        const pendientes = {};
        snap.docs.forEach(d => { if (d.data().clubId) pendientes[d.data().clubId] = true; });
        setSolicitudesEnviadas(pendientes);
      }).catch(() => {});
  }, [userId]);

  const solicitarUnirse = async (club) => {
    if (!userId || enviando) return;
    setEnviando(club.id);
    try {
      await addDoc(collection(db, 'alertas'), {
        tipo: 'solicitud_club',
        emisorId: userId,
        emisorNombre: perfil?.nombre || 'Alguien',
        emisorFoto: perfil?.foto || null,
        destinatarioId: club.creadorId,
        club: club.nombre,
        clubId: club.id,
        fecha: serverTimestamp(),
        leida: false,
      });
      setSolicitudesEnviadas(prev => ({ ...prev, [club.id]: true }));
    } catch (e) { console.error(e); }
    setEnviando(null);
  };

  if (clubActivo) {
    return <ChatClub club={clubActivo} userId={userId} perfil={perfil} onVolver={() => setClubActivo(null)} />;
  }

  const TABS = [
    { id: 'activos', label: 'Clubs activos' },
    { id: 'mis',     label: 'Mis clubs', count: misClubs.length },
  ];

  // Card de club reutilizable
  const ClubCard = ({ club, esMio }) => {
    const soyMiembro = club.miembros?.includes(userId);
    const yaSolicitado = solicitudesEnviadas[club.id];
    const soyCreador = club.creadorId === userId;
    const esVerificadoClub = club.verificado === 'autor' || club.verificado === 'editorial';
    const limite = esVerificadoClub ? '∞' : 50;
    return (
      <div style={{ background: '#141414', borderRadius: '12px', padding: '16px 20px', border: '1px solid #1e1e1e', display: 'flex', alignItems: 'center', gap: '14px', cursor: soyMiembro ? 'pointer' : 'default', transition: '0.2s' }}
        onClick={() => soyMiembro ? setClubActivo(club) : null}
        onMouseEnter={e => { if (soyMiembro) { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.background = '#181818'; }}}
        onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e1e1e'; e.currentTarget.style.background = '#141414'; }}>
        {/* Icono */}
        <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #0a1f0a, #1DB95422)', border: '1px solid #1DB95433', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#1DB954">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
        </div>
        {/* Info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', marginBottom: '3px' }}>
            <p style={{ margin: 0, fontWeight: 900, fontSize: '15px', color: 'white' }}>{club.nombre}</p>
            {esVerificadoClub && (
              <span style={{ background: 'linear-gradient(135deg, #0ea5e9, #0369a1)', color: 'white', fontSize: '9px', padding: '1px 6px', borderRadius: '20px', fontWeight: 'bold' }}>✦ Verificado</span>
            )}
          </div>
          <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>
            {club.miembros?.length || 1} miembro{(club.miembros?.length || 1) !== 1 ? 's' : ''}
            <span style={{ color: '#333' }}> / {limite}</span>
            {soyCreador && <span style={{ color: '#1DB954', marginLeft: '8px' }}>· Admin</span>}
          </p>
          {club.descripcion && <p style={{ margin: '3px 0 0', fontSize: '11px', color: '#444', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{club.descripcion}</p>}
        </div>
        {/* Acción */}
        {soyMiembro ? (
          <span style={{ color: '#333', fontSize: '20px', flexShrink: 0 }}>›</span>
        ) : (
          <button
            disabled={yaSolicitado || enviando === club.id}
            onClick={e => { e.stopPropagation(); solicitarUnirse(club); }}
            style={{ background: yaSolicitado ? 'transparent' : '#1DB954', color: yaSolicitado ? '#1DB954' : 'black', border: yaSolicitado ? '1px solid #1DB95444' : 'none', borderRadius: '20px', padding: '8px 16px', fontWeight: 'bold', cursor: yaSolicitado ? 'default' : 'pointer', fontSize: '12px', flexShrink: 0, opacity: enviando === club.id ? 0.6 : 1, transition: '0.2s' }}>
            {yaSolicitado ? '✓ Solicitud enviada' : enviando === club.id ? 'Enviando...' : 'Solicitar unirse'}
          </button>
        )}
      </div>
    );
  };

  return (
    <div style={{ padding: '0 28px 60px' }}>
      {modalCrear && <ModalCrearClub userId={userId} perfil={perfil} onCerrar={() => setModalCrear(false)} onCreado={id => { const club = misClubs.find(c => c.id === id); if (club) setClubActivo(club); }} />}
      {modalUnirse && <ModalUnirseClub userId={userId} perfil={perfil} onCerrar={() => setModalUnirse(false)} onUnido={() => {}} />}

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', margin: '32px 0 24px' }}>
        <div>
          <h1 style={{ fontSize: '36px', margin: '0 0 4px', fontWeight: 900 }}>Clubs</h1>
          <p style={{ color: '#555', margin: 0, fontSize: '13px' }}>Descubre grupos de lectura o crea el tuyo</p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => setModalUnirse(true)} className="btn-outline" style={{ padding: '10px 16px', width: 'auto', marginTop: 0 }}>
            Unirse con código
          </button>
          <button onClick={() => puedeCrear ? setModalCrear(true) : onUpgrade()}
            style={{ background: '#1DB954', color: 'black', border: 'none', borderRadius: '25px', padding: '10px 16px', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px' }}>
            + Crear club
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '24px' }}>
        {TABS.map(t => {
          const activo = tab === t.id;
          return (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{ background: activo ? '#1DB95418' : 'transparent', color: activo ? '#1DB954' : '#555', border: `1px solid ${activo ? '#1DB95455' : '#222'}`, borderRadius: '20px', padding: '7px 16px', cursor: 'pointer', fontWeight: activo ? 'bold' : 'normal', fontSize: '13px', transition: '0.2s', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>{t.label}</span>
              {t.count !== undefined && t.count > 0 && (
                <span style={{ background: activo ? '#1DB95433' : '#1a1a1a', color: activo ? '#1DB954' : '#555', borderRadius: '10px', padding: '1px 6px', fontSize: '10px', fontWeight: 'bold' }}>{t.count}</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Clubs activos */}
      {tab === 'activos' && (
        cargandoPublicos ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {[...Array(3)].map((_, i) => <div key={i} style={{ height: '80px', background: '#141414', borderRadius: '12px', animation: 'pulse 1.5s infinite' }} />)}
          </div>
        ) : clubsPublicos.length === 0 ? (
          <div style={{ textAlign: 'center', marginTop: '60px' }}>
            <p style={{ color: '#555', fontSize: '14px' }}>Aún no hay clubs creados.</p>
            <button onClick={() => setModalCrear(true)} className="btn-verde" style={{ width: 'auto', padding: '10px 24px', marginTop: '16px' }}>Crear el primero</button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {clubsPublicos.map(club => <ClubCard key={club.id} club={club} />)}
          </div>
        )
      )}

      {/* Mis clubs */}
      {tab === 'mis' && (
        cargando ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {[...Array(2)].map((_, i) => <div key={i} style={{ height: '80px', background: '#141414', borderRadius: '12px', animation: 'pulse 1.5s infinite' }} />)}
          </div>
        ) : misClubs.length === 0 ? (
          <div style={{ textAlign: 'center', marginTop: '80px' }}>
            <p style={{ fontWeight: 900, fontSize: '18px', margin: '0 0 8px', color: 'white' }}>Aún no perteneces a ningún club</p>
            <p style={{ color: '#555', fontSize: '13px', margin: '0 0 24px' }}>Solicita unirte desde "Clubs activos" o crea el tuyo</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={() => setTab('activos')} className="btn-outline" style={{ width: 'auto', marginTop: 0, padding: '10px 20px' }}>Ver clubs activos</button>
              <button onClick={() => setModalCrear(true)} className="btn-verde" style={{ width: 'auto', padding: '10px 20px' }}>Crear club</button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {misClubs.map(club => <ClubCard key={club.id} club={club} esMio />)}
          </div>
        )
      )}
    </div>
  );
}
